import {
  AdminDollarInput2,
  Button,
  Div,
  Modal,
  PropsModal,
  SuccessToast,
  updateMenuPosModifierOption,
  reportError,
} from '@vgrubs/components';
import {
  MenuV2Response,
  ModifierItemV2Response,
} from 'components/src/types/menu.types';
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useParams } from 'react-router';

export const EditOptionPriceModal = ({
  editOptionPriceModal,
  closeModal,
  setMenu,
  setLoading,
  handleChangeShouldPublish,
}: PropsModal & {
  editOptionPriceModal: ModifierItemV2Response | null;
  setMenu: Dispatch<SetStateAction<MenuV2Response | null>>;
  handleChangeShouldPublish: (shouldPublish: boolean) => void;
}) => {
  const [optionPrice, setOptionPrice] = useState(0);

  const [isDisabled, setIsDisabled] = useState(false);

  const modifierItem = editOptionPriceModal;

  const handleValueTotalChange = useCallback((val: number) => {
    setOptionPrice(val);
  }, []);

  useEffect(() => {
    if (typeof modifierItem === 'object') {
      setOptionPrice(modifierItem?.price || 0);
      if (modifierItem?.price !== undefined) {
        setIsDisabled(modifierItem?.price < 1);
      }
    }
  }, [modifierItem]);

  const { locationId, brandId } = useParams() as {
    locationId: string;
    brandId: string;
  };

  async function handleEditOptionPrice() {
    if (!modifierItem?.id) return;
    try {
      setLoading?.(true);
      const { data } = await updateMenuPosModifierOption(
        locationId,
        brandId,
        modifierItem?.posId ?? 0,
        {
          price: optionPrice,
        }
      );

      setMenu(data?.data);
      handleChangeShouldPublish(true);
      SuccessToast(data?.message);
      closeModal?.();
    } catch (error) {
      reportError(error);
    } finally {
      setLoading?.(false);
    }
  }

  return (
    <Modal
      isOpen={!!editOptionPriceModal}
      closeModal={closeModal}
      header={`Edit Option Price`}
      logo={false}
      zIndex={101}
      // width="850px"
    >
      <AdminDollarInput2
        label="Modifier Price"
        $textCenter
        onValueChange={handleValueTotalChange}
        value={optionPrice}
        disabled={isDisabled}
      />

      <Div $flex $gap="16px" $mt="24">
        <Button $selected $w="100%" onClick={handleEditOptionPrice}>
          Confirm
        </Button>
        <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
